import axios from 'axios';

const API_BASE_URL = "https://beta.autotrak.ai/api/";
const TRACKING_BASE_URL = "https://beta.autotrak.ai/db_insight/";

// Default axios instance (for general API calls)
const axiosInstance = axios.create({
    baseURL: API_BASE_URL,
    headers: {
        "Content-Type": "application/json",
    },
});

// Function to create axios instance with a dynamic baseURL
export const getAxiosInstance = (endpointType) => {
    const baseURL = endpointType === "tracking" ? TRACKING_BASE_URL : API_BASE_URL;

    return axios.create({
        baseURL,
        headers: {
            "Content-Type": "application/json",
        },
    });
};

export default axiosInstance;
